import { ViewportElementExtension } from '@blocksuite/hive-shared/services';
import { keyboardToolbarWidget } from '@blocksuite/hive-widget-keyboard-toolbar';
import { IS_MOBILE } from '@blocksuite/global/env';
import { BlockViewExtension, WidgetViewExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal, unsafeStatic } from 'lit/static-html.js';

import { PageClipboard } from '../clipboard/page-clipboard.js';
import { CommonSpecs } from '../common-specs/index.js';
import { HIVE_PAGE_DRAGGING_AREA_WIDGET } from '../widgets/page-dragging-area/page-dragging-area.js';
import { PageRootService } from './page-root-service.js';

export const pageDraggingAreaWidget = WidgetViewExtension(
  'hive:page',
  HIVE_PAGE_DRAGGING_AREA_WIDGET,
  literal`${unsafeStatic(HIVE_PAGE_DRAGGING_AREA_WIDGET)}`
);

const PageCommonExtension: ExtensionType[] = [
  CommonSpecs,
  PageRootService,
  pageDraggingAreaWidget,
  ViewportElementExtension('.hive-page-viewport'),
].flat();

export const PageRootBlockSpec: ExtensionType[] = [
  ...PageCommonExtension,
  BlockViewExtension('hive:page', literal`hive-page-root`),
  IS_MOBILE ? [keyboardToolbarWidget] : [],
  PageClipboard,
].flat();

export const PreviewPageRootBlockSpec: ExtensionType[] = [
  ...PageCommonExtension,
  BlockViewExtension('hive:page', literal`hive-preview-root`),
];
